module.exports = __webpack_public_path__ + "static/media/psi-new-logohj.c3f3dac9.png";